import { metricsTrack } from '../../utilities/analytics/index.js';
import '../../atoms/buttons/enums.js';
import '../../utilities/dom-helpers/index.js';

const trackVideoPosition = () => {
    let percentReached = 0;
    // eslint-disable-next-line func-names
    return function (e, videoName) {
        const percent = Math.round((e.target.currentTime / e.target.duration) * 100);
        const trackProgress = (position) => {
            metricsTrack('cevt_video_progress', {
                dlv_event_category: 'video',
                dlv_event_action: `progress ${position}%`,
                dlv_video_title: videoName,
                dlv_video_url: e.target.querySelector('source').src,
                dlv_video_provider: 'MarketingZone',
                dlv_video_progress: position,
                dlv_video_duration: Math.round(e.target.duration),
                dlv_video_current_time: Math.round(e.target.currentTime),
            });
        };
        // When the user reaches 10%, 25%, 50%, 75% and 90% of the video
        if ([10, 25, 50, 75, 90].includes(percent) && percentReached !== percent) {
            trackProgress(percent);
            percentReached = percent;
        }
    };
};
const trackYoutubeVideoPosition = () => {
    let percentReached = 0;
    // eslint-disable-next-line func-names
    return function (url, videoName, duration, progress, isPlaying) {
        if (!isPlaying)
            return;
        const percent = Math.round((progress / duration) * 100);
        const trackProgress = () => metricsTrack('cevt_video_progress', {
            dlv_event_category: 'video',
            dlv_event_action: `progress ${percent}%`,
            dlv_video_title: videoName,
            dlv_video_url: url,
            dlv_video_provider: 'Youtube',
            dlv_video_progress: percent,
            dlv_video_duration: duration,
            dlv_video_current_time: Math.round(progress),
        });
        if ([10, 25, 50, 75, 90].includes(percent) && percent !== percentReached) {
            percentReached = percent;
            trackProgress();
        }
    };
};
const trackVideoStarted = (e, videoName) => {
    metricsTrack('cevt_video_start', {
        dlv_event_category: 'video',
        dlv_event_action: 'start',
        dlv_video_title: videoName,
        dlv_video_url: e.target.querySelector('source').src,
        dlv_video_provider: 'MarketingZone',
    });
};
const trackYoutubeVideoStarted = (url, videoName) => {
    metricsTrack('cevt_video_start', {
        dlv_event_category: 'video',
        dlv_event_action: 'start',
        dlv_video_title: videoName,
        dlv_video_url: url,
        dlv_video_provider: 'Youtube',
    });
};
const trackYoutubeVideoEnded = (url, videoName) => {
    metricsTrack('cevt_video_complete', {
        dlv_event_category: 'video',
        dlv_event_action: 'complete',
        dlv_video_title: videoName,
        dlv_video_url: url,
        dlv_video_provider: 'Youtube',
    });
};

export { trackVideoPosition, trackVideoStarted, trackYoutubeVideoEnded, trackYoutubeVideoPosition, trackYoutubeVideoStarted };
